import dayjs, { Dayjs } from 'dayjs';

export const DISPLAY_DATE_FORMAT = 'MM/DD/YYYY';
export const DISPLAY_DATE_TIME_FORMAT = 'MM/DD/YYYY HH:mm';
export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const formatDateForDisplay = (
  date: string | Date | Dayjs | null | undefined
): string => {
  if (!date) return '';

  const dayjsDate = dayjs.isDayjs(date) ? date : dayjs(date);
  if (!dayjsDate.isValid()) return '';

  return dayjsDate.format(DISPLAY_DATE_FORMAT);
};

export const formatDateTimeForDisplay = (
  date: string | Date | Dayjs | null | undefined
): string => {
  if (!date) return '';

  const dayjsDate = dayjs.isDayjs(date) ? date : dayjs(date);
  if (!dayjsDate.isValid()) return '';

  return dayjsDate.format(DISPLAY_DATE_TIME_FORMAT);
};

export const formatDateForAPI = (
  date: string | Date | Dayjs | null | undefined
): string => {
  if (!date) return '';

  const dayjsDate = dayjs.isDayjs(date)
    ? date
    : typeof date === 'string'
      ? dayjs(date, DISPLAY_DATE_FORMAT)
      : dayjs(date);

  if (!dayjsDate.isValid()) return '';

  return dayjsDate.format(API_DATE_FORMAT);
};

export const formatDatesInErrorMessage = (message: string): string => {
  // Match ISO date format (YYYY-MM-DD)
  const isoDateRegex = /\b(\d{4})-(\d{2})-(\d{2})\b/g;

  return message.replace(isoDateRegex, (match) => {
    const formatted = formatDateForDisplay(match);
    return formatted || match;
  });
};
